import { FC, ReactElement } from 'react'

import { Page } from '../../components'
import { ConnectedChangeLogEntries } from '../../connectors'

export const ChangeLogEntriesPage: FC = (): ReactElement => (
    <Page>
        <ConnectedChangeLogEntries />
    </Page>
)
